<div
  class="lui-drawer-backdrop"
  (click)="_onBackdropClicked()"
  *ngIf="hasBackdrop"
  [class.lui-drawer-shown]="_isShowingBackdrop()"
  [class.lui-drawer-backdrop-fixed]="_isBackdropFixed"
></div>

<lui-drawer-content>
  <ng-content></ng-content>
</lui-drawer-content>
<ng-content select="lui-drawer"></ng-content>
